module.exports = __webpack_public_path__ + "assets/img/2019_4.30320aa6.png";